import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/amenitiesDetailsPages/SportsClubPageComponent.tsx");
